import { Action } from '@ngrx/store';
import { ActivateTrialLicenseModel, ActivateTrialLicenseParams } from '../activate-trial-license.model';

export enum ActivateTrialLicenseActionTypes {
  LoadActivateTrialLicenses = '[ActivateTrialLicense] Load ActivateTrialLicenses',
  GetActivateTrialLicense = '[ActivateTrialLicense] Get ActivateTrialLicense',
  ClearActivateTrialLicenses = '[ActivateTrialLicense] Clear ActivateTrialLicenses'
}

export class LoadActivateTrialLicenses implements Action {
  readonly type = ActivateTrialLicenseActionTypes.LoadActivateTrialLicenses;
  constructor(public payload: ActivateTrialLicenseModel) {}
}

export class GetActivateTrialLicense implements Action {
  readonly type = ActivateTrialLicenseActionTypes.GetActivateTrialLicense;
  constructor(public payload: ActivateTrialLicenseParams) {}
}

export class ClearActivateTrialLicenses implements Action {
  readonly type = ActivateTrialLicenseActionTypes.ClearActivateTrialLicenses;
}

export type ActivateTrialLicenseActions =
 LoadActivateTrialLicenses
 | GetActivateTrialLicense
 | ClearActivateTrialLicenses;
